import { useParams } from "react-router-dom"
import AdminModelView from './model_view'
import DepartamentTypeObjectTypeAdminModelView from "./department_type_object_type/model_view"
import MembershipsRefAdminModelView from "./memberships_ref/model_view"
import DocumentTypeRefAdminModelView from "./document_type_ref/model_view"
import DocumentFileAccessRefAdminModelView from "./document_file_access_ref/model_view"

/** Кастомные классы для обработок каждой админки регистрируются тут **/

const MODEL_MAP = {
  DepartmentTypeObjectType: DepartamentTypeObjectTypeAdminModelView,
  MembershipsRef: MembershipsRefAdminModelView,
  DocumentTypeRef: DocumentTypeRefAdminModelView,
  DocumentFileAccessRef: DocumentFileAccessRefAdminModelView,
}

export function AdminModelViewRouter(props) {
  const { model_name } = useParams()
  const Component = MODEL_MAP[model_name] || AdminModelView
  return <Component {...props} />
}